import Bowser from 'bowser'
import MobileDetect from 'mobile-detect'
import config from '../config'
/**
 * Detects the browser based on userAgent
 * @returns {Object}
 */
export const getUserAgentObject = () => {
  const ua = navigator.userAgent || navigator.vendor || window.opera

  const isIEorEdge =
    navigator.appName === 'Microsoft Internet Explorer' ||
    (navigator.appName === 'Netscape' && navigator.appVersion.indexOf('Edge') > -1)

  const isFBBrowser = ua.indexOf('FBAN') > -1 || ua.indexOf('FBAV') > -1

  const browserDetails = Bowser.parse(window.navigator.userAgent)

  const isFirefox = browserDetails.browser.name === 'Firefox'

  const isSafari = browserDetails.browser.name === 'Safari'

  const isIOSBrowser = browserDetails.os.name === 'iOS'

  return {
    isFirefox,
    isIEorEdge,
    isFBBrowser,
    isSafari,
    isIOSBrowser
  }
}

/**
 * Get device details
 * @returns {Object}
 * {
 *  userAgent,
 *  device
 * }
 */
export const getDeviceDetails = () => {
  const devices = config.DEVICE_TYPES
  const md = new MobileDetect(navigator.userAgent)
  const device = md.mobile() ? devices.MOBILE : md.tablet() ? devices.TABLET : devices.DESKTOP
  return {
    userAgent: navigator.userAgent,
    device
  }
}
